import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import "components/ROB/components/ROBList/ROBList.scss";
import { getTranslatedLabel } from "utils/common";

import type { ReactNode } from "react";

type ROBListProps = {
  list: Record<string, unknown>[];
  title: string;
  onRenderEntry: (entry: Record<string, unknown>) => ReactNode;
};

export const ROBList = ({ list, title, onRenderEntry }: ROBListProps) => {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(0);

  const handleGetNextPage = () => setCurrentPage(currentPage + 1);
  const handleGetPreviousPage = () => setCurrentPage(currentPage - 1);

  if (!list.length) return null;

  return (
    <div className="ROBList">
      <div className="list_title">
        {getTranslatedLabel(title, t)}
        {list.length > 1 && (
          <div className="controls">
            <Button disabled={currentPage < 1} className="left-btn" onClick={handleGetPreviousPage}>
              <Icon className="angle left" />
            </Button>
            <Button disabled={currentPage > list.length - 2} className="right-btn" onClick={handleGetNextPage}>
              <Icon className="angle right" />
            </Button>
          </div>
        )}
      </div>
      {onRenderEntry(list[currentPage])}
    </div>
  );
};
